import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import { AppState } from '../../../data/state'

interface CO2SummaryProps {
  co2Compensation: boolean
}

const CO2Summary: React.FC<CO2SummaryProps> = ({ co2Compensation }) => {
  return co2Compensation ? (
    <ListItem>
      <DisplayContent addNode contentKey="co2-summary">
        CO2 compensated
      </DisplayContent>
    </ListItem>
  ) : null
}

export default connect((state: AppState) => ({
  co2Compensation: state.funnelOrder.co2Compensation,
}))(CO2Summary)
